import { AfterContentChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input';
import { EcomValidator } from 'src/app/ecom-services/ecom-validation';
import { HttpResponse } from '@angular/common/http';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { EcomCookies } from '../../../ecom-services/ecom-cookies';
import { EComGoogleAnalytics } from '@src/app/ecom-services/ecom-google-analytics';

@Component({
  selector: 'app-ecom-profile-edit',
  templateUrl: './ecom-profile-edit.component.html',
  styleUrls: ['./ecom-profile-edit.component.scss']
})
export class EcomProfileEditComponent implements OnInit, AfterContentChecked {
  // component class properties
  public userForm: FormGroup;
  userImageURL: any = './assets/images/profile.png';
  errorMessage: any;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];
  selectedCountryISO = CountryISO.Malaysia;
  successMessage: any;
  userServiceBase: UserServiceBase;

  // constructor to inject the class objects
  constructor(private eComGoogleAnalytics:EComGoogleAnalytics,public formBuilder: FormBuilder, private ref: ChangeDetectorRef, public router: Router,
    public ecomservice: EComService, public webstorage: EComWebStorage, private cookie: EcomCookies) {
    this.userServiceBase = new UserServiceBase();
  }

  ngAfterContentChecked() {
    this.ref.detectChanges();
  }

  // component initialize and load the required data
  ngOnInit() {
    let gTag = {
      'event':'screen_view',
      'screen_name':'profile edit'
    };
    this.eComGoogleAnalytics.customEvent(gTag);
    if(!this.webstorage.sessionSt_is_session_valid){
      this.router.navigate(['home']);
    }
    this.userServiceBase = this.webstorage.localSt_user_service_request ? this.webstorage.localSt_user_service_request : new UserServiceBase();
    //this.selectCountyCode();
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    this.userForm = this.formBuilder.group({
      firstname: ['', Validators.compose([Validators.required])],
      lastname: [''],
      countryCode: [{ disabled: true }],
      mobile: [{ value: '', disabled: true }, Validators.compose([Validators.required])],
      email: ['', Validators.compose([EcomValidator.emailValidator])],
      imagename: ['']
    });
    if (this.webstorage.localSt_user_id === null) {
      this.router.navigate(['login']);
    } else {
      this.LoadPage();
    }

  }

  LoadPage() {
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      this.ecomservice.httpPost(url, {}, '', true).subscribe((response) => {
        if (response.isSuccess) {
          if (!this.webstorage.localSt_client_id) {
            this.webstorage.localSt_client_id = response.listValue.oock_client_id;
          }
          // store public key
          this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
          this.getUser();
        }
      });
    } else {
      this.getUser();
    }
  }

  selectCountyCode() {
    // get user country code to display country suggetion for phone pickup
    if (this.cookie.cookie_country_code) {
      this.setCountryCode();
    } else {
      let url = 'https://api.ipgeolocation.io/ipgeo?apiKey=b610cefa4e2f4665a05094c0bee82ad6'
      this.ecomservice.httpGetOuterResponseHeader(url, '', false).subscribe((response: HttpResponse<any>) => {
        let countryCode = 'MY';
        if (response.status === 200) {
          countryCode = response.body.country_code2;
          //this.webstorage.localSt_user_country_code = response.body.country_code2;
        }
        this.cookie.cookie_country_code = countryCode;
        this.setCountryCode();
      });
    }
  }

  setCountryCode() {
    switch (this.cookie.cookie_country_code) {
      case 'MY':
        this.selectedCountryISO = CountryISO.Malaysia;
        this.preferredCountries = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];
        break;
      case 'SG':
        this.selectedCountryISO = CountryISO.Singapore;
        this.preferredCountries = [CountryISO.Singapore, CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Indonesia, CountryISO.Thailand];
        break;
      case 'ID':
        this.selectedCountryISO = CountryISO.Indonesia;
        this.preferredCountries = [CountryISO.Indonesia, CountryISO.Singapore, CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Thailand];
        break;
      case 'IN':
        this.selectedCountryISO = CountryISO.India;
        this.preferredCountries = [CountryISO.India, CountryISO.Indonesia, CountryISO.Singapore, CountryISO.Malaysia, CountryISO.Australia, CountryISO.Thailand];
        break;
      case 'AU':
        this.selectedCountryISO = CountryISO.Australia;
        this.preferredCountries = [CountryISO.Australia, CountryISO.India, CountryISO.Indonesia, CountryISO.Singapore, CountryISO.Malaysia, CountryISO.Thailand];
        break;
      case 'TH':
        this.selectedCountryISO = CountryISO.Thailand;
        this.preferredCountries = [CountryISO.Thailand, CountryISO.Australia, CountryISO.India, CountryISO.Indonesia, CountryISO.Singapore, CountryISO.Malaysia];
        break;
      default:
        this.selectedCountryISO = CountryISO.Malaysia;
        this.preferredCountries = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];
        break;
    }
  }

  // Method to get the user details by userid
  getUser() {
    const userId = this.webstorage.localSt_user_id;
    this.ecomservice.httpGet(EcomNetworkUtils.GET_PROFILE + '?Id=' + userId, '', true).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {
          this.userForm.controls.firstname.setValue(response.listValue.ooc_customer_firstname);
          this.userForm.controls.lastname.setValue(response.listValue.ooc_customer_lastname);
          this.userForm.controls.mobile.setValue(response.listValue.ooc_customer_mobile);
          this.userForm.controls.countryCode.setValue(response.listValue.ooc_country_dial_code);
          this.selectedCountryISO = response.listValue.ooc_country_dial_code.toLowerCase();
          this.userForm.controls.email.setValue(response.listValue.ooc_customer_email);
          this.userForm.controls.imagename.setValue(response.listValue.ooc_customer_imagename);
          if (response.listValue.ooc_customer_imagename.length > 0) {
            this.userImageURL = response.listValue.ooc_customer_imagename;
          }
        } else {
          this.errorMessage = response.msg;
          this.router.navigate(['login']);
          this.ecomservice.commonLoading.show = false;
        }
      }
    });
  }

  // Method to handle the save click event
  onSaveClick() {
    this.successMessage = undefined;
    this.errorMessage = undefined;
    if (this.userForm.invalid) {
      Object.keys(this.userForm.controls).forEach(key => {
        this.userForm.get(key).markAsDirty();
      });
      return;
    } else {
      const input = {
        'ooc_guid': this.webstorage.localSt_user_id,
        'ooc_customer_firstname': this.ecomservice.encryptWithKey(this.userForm.value.firstname),
        'ooc_customer_lastname': this.userForm.value.lastname ? this.ecomservice.encryptWithKey(this.userForm.value.lastname) : '',
        'ooc_customer_mobile': this.ecomservice.encryptWithKey(this.userForm.getRawValue().mobile.number),
        'ooc_country_dial_code': this.ecomservice.encryptWithKey(this.userForm.getRawValue().mobile.countryCode),
        'ooc_customer_email': this.userForm.value.email ? this.ecomservice.encryptWithKey(this.userForm.value.email) : '',
        'ooc_customer_imagename': this.userForm.value.imagename,
        customer_client_key: this.webstorage.localSt_client_id,
        customer_key: this.webstorage.localSt_olar_key
      };
      this.ecomservice.httpPost(EcomNetworkUtils.POST_PROFILE_UPDATE, input, '', true).subscribe(response => {
        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
        } else {
          if (response.isSuccess) {
            this.userServiceBase.userDialCode = this.userForm.getRawValue().mobile.countryCode;
            this.userServiceBase.userMobile = this.userForm.getRawValue().mobile.number;
            this.userServiceBase.userName = this.userForm.value.firstname;
            this.webstorage.localSt_name = this.userForm.value.firstname;
            this.userServiceBase.userEmail = this.userForm.value.email;
            this.webstorage.localSt_user_service_request = this.userServiceBase;
            this.successMessage = 'Details updated!';
          } else {
            this.errorMessage = response.msg;
          }
        }
      });
    }
  }

  // Method to handle the back button click
  onBackClick() {
    if (this.webstorage.sessionSt_frompage) {
      this.router.navigate([this.webstorage.sessionSt_frompage]);
    } else {
      this.router.navigate(['login']);
    }
  }

  // Method to handle the image file select event
  onSelectFile(event) {
    this.errorMessage = null;
    if (event.target.files && event.target.files[0]) {
      const mimeType = event.target.files[0].type;
      if (mimeType.match(/image\/*/) == null) {
        this.errorMessage = "Only images are supported";
        return;
      }
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event) => { // called once readAsDataURL is completed
        this.userImageURL = event.target['result'];
        // base64 encoded image data
        this.userForm.controls.imagename.setValue(this.userImageURL);
      }
    }
  }
}
